import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'
import { isEmpty } from '@eastcoal/common/utils/object'

import {
  DataField,
  Form,
  onFieldInputValueChange,
  onFieldReact
} from '@eastcoal/formily/exports/core'

import { FeeMethod, FeeMethodTextMap } from '@eastcoal/shared/enums/FeeMethod'

import { PRICING_METHOD_FIELD, SERVICE_FEE_FIELD } from '../../constants/field'

const PRICE_METHOD_NAME_ARRAY = ['卡', '(千卡/千克)·吨', '吨']
/**
 * “服务费方式”联动逻辑
 */
const clearValue = (_: unknown, form: Form) => {
  const serviceFeeField = form.query(SERVICE_FEE_FIELD).take() as DataField
  if (!isEmpty(serviceFeeField?.value)) {
    serviceFeeField?.onInput({ serviceFeeMethod: FeeMethod.NONE })
  }
}

const updateState = (_: unknown, form: Form) => {
  const { pricingMethodName } = form.values
  const serviceFeeField = form.query(SERVICE_FEE_FIELD).take() as DataField
  // 当计价方式不属于price_method_name_array集合时，不显示【按数量收取】选项
  serviceFeeField?.setComponentProps({
    selectOptions: !PRICE_METHOD_NAME_ARRAY.includes(pricingMethodName)
      ? mapNumberEnumOptions(FeeMethodTextMap).filter(
          item => item.value !== FeeMethod.QUANTITY
        )
      : undefined
  })
}

export const serviceFeeMethodEffect = () => {
  onFieldInputValueChange(PRICING_METHOD_FIELD, clearValue)
  onFieldReact(PRICING_METHOD_FIELD, updateState)
}
